import React, { Component }                 from 'react';
import { connect }                          from 'react-redux';
import { bindActionCreators }               from 'redux';
import * as viewElements                    from '../../../infrastructure/actions/creators/view-elements';
import UiKit                                from '../../uikit';
import {
    Container,
    Header,
    ContentWrapper
}                                           from './components'; 
import { TransitionGroup, CSSTransition }   from 'react-transition-group';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state      = { }
        this.zIndex     = '100';

        this.onCloseHandler      = this.onCloseHandler.bind(this);
    }

    onCloseHandler(modal) {
        let {
            actions
        } = this.props;
        actions.removeModal(modal)
    }

    createBodyDOM(m) {
        let body = m.get('body');
        if(typeof body !== 'string') {
            let Comp = m.toJS().body
            return <Comp closeModal={ () => this.onCloseHandler(m) } />
        }
        return body
    }

    render() {
        let { modals }= this.props;
        return (
            <UiKit.Portal
                zIndex={ this.zIndex }
            >
                <TransitionGroup className="modal-transition">
                    {
                        modals && modals.map((m, i) =>
                            <CSSTransition
                                appear      = { true }
                                unmountOnExit
                                classNames  = 'modal'
                                timeout     = { 200 }
                                key         = {`modal-${i}`} 
                            >
                                <Container>
                                    <ContentWrapper
                                        onBlur = { () => this.onCloseHandler(m) }
                                    >
                                        {
                                            m.get('title') 
                                                ?   <Header 
                                                        title       = { m.get('title') }
                                                        onClose     = { () => this.onCloseHandler(m) }
                                                    />
                                                :   null
                                            }
                                        
                                        <div className="simprakit-modal-body">
                                            { 
                                                this.createBodyDOM(m)
                                            }
                                        </div>
                                    </ContentWrapper>
                                </Container>
                            </CSSTransition>
                        )
                    }
                </TransitionGroup>
            </UiKit.Portal>
        )
    }
}

const mapStateToProps = state => ({
    modals: state.getIn(['ui', 'runtime', 'viewElements', 'modals'])
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(viewElements, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Modal);